import { LifeCycleActionDispatch, LifeCycleReduxTypes } from "./types";

export const createLifeCycle = (payload: any): LifeCycleActionDispatch => ({
    type: LifeCycleReduxTypes.LIFE_CYCLE_REPORT,
    payload: payload
})

export const resetLifeCycle = () : LifeCycleActionDispatch=>({
    type: LifeCycleReduxTypes.RESET_LIFE_CYCLE,
    payload:{}
})